import DOMPurify from 'dompurify'

// Artemis answers are HTML built from model output, so they are sanitized before they reach
// the page (WEB-7092). The allow-list is the one in the Artemis client integration guide,
// plus <br>. Links may only point at http(s) or mailto and always open in a new tab.

const ALLOWED_TAGS = ['p', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'br']
const ALLOWED_ATTR = ['href']
const SAFE_HREF = /^(https?:|mailto:)/i

let purifier = null

const getPurifier = () => {
    if (purifier) return purifier
    purifier = DOMPurify(window)
    purifier.addHook('afterSanitizeAttributes', node => {
        if (node.tagName !== 'A') return
        const href = (node.getAttribute('href') || '').trim()
        if (!SAFE_HREF.test(href)) node.removeAttribute('href')
        else {
            node.setAttribute('target', '_blank')
            node.setAttribute('rel', 'noopener noreferrer')
        }
    })
    return purifier
}

export const sanitizeAnswerHtml = html => {
    if (!html) return ''
    return getPurifier().sanitize(html, {
        ALLOWED_TAGS,
        // target and rel are set by the hook, after DOMPurify's own attribute pass.
        ALLOWED_ATTR,
        KEEP_CONTENT: true
    })
}

// Turns each [n] in sanitized answer HTML into a chip linking citation n (citation events, see the
// Artemis guide). A marker with no citation, or one whose link isn't http(s), is left as text.
export const linkCitations = (html, citations = []) => {
    if (!html || citations.length === 0) return html
    const byIndex = new Map(citations.map(c => [c.index, c]))
    const doc = new window.DOMParser().parseFromString(`<body>${html}</body>`, 'text/html')
    const walker = doc.createTreeWalker(doc.body, window.NodeFilter.SHOW_TEXT)
    const texts = []
    while (walker.nextNode()) if (/\[\d+\]/.test(walker.currentNode.nodeValue)) texts.push(walker.currentNode)

    texts.forEach(node => {
        if (node.parentNode.closest && node.parentNode.closest('a')) return
        const fragment = doc.createDocumentFragment()
        node.nodeValue.split(/(\[\d+\])/).forEach(part => {
            const match = /^\[(\d+)\]$/.exec(part)
            const citation = match && byIndex.get(Number(match[1]))
            const href = citation && (citation.citeUrl || citation.url)
            if (!href || !SAFE_HREF.test(href) || /^mailto:/i.test(href)) {
                if (part) fragment.appendChild(doc.createTextNode(part))
                return
            }
            const a = doc.createElement('a')
            a.className = 'artemis-cite'
            a.setAttribute('href', href)
            a.setAttribute('target', '_blank')
            a.setAttribute('rel', 'noopener noreferrer')
            if (citation.title) a.setAttribute('title', citation.title)
            a.textContent = match[1]
            fragment.appendChild(a)
        })
        node.parentNode.replaceChild(fragment, node)
    })
    return doc.body.innerHTML
}
